<!-- <div class="main-content">
  <div class="container-fluid">
    <div class="form-container">
      <div class="card">
        <div class="card-header">
          <h4>{{ id ? "Editar" : "Crear" }} Surcharge</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="name">Nombre *</label>
              <input
                type="text"
                class="form-control"
                id="name"
                formControlName="name"
              />
              <div
                class="error-message"
                *ngIf="form.get('name')?.invalid && form.get('name')?.touched"
              >
                El nombre es requerido
              </div>
            </div>

            <div class="form-group">
              <label for="items">Items *</label>
              <textarea
                class="form-control"
                id="items"
                rows="3"
                formControlName="items"
                placeholder="Ingrese los items separados por comas"
              ></textarea>
              <div
                class="error-message"
                *ngIf="form.get('items')?.invalid && form.get('items')?.touched"
              >
                Los items son requeridos
              </div>
            </div>

            <div class="form-group">
              <label for="surcharge">Surcharge ($) *</label>
              <input
                type="number"
                class="form-control"
                id="surcharge"
                formControlName="surcharge"
                min="0"
              />
              <div
                class="error-message"
                *ngIf="
                  form.get('surcharge')?.invalid &&
                  form.get('surcharge')?.touched
                "
              >
                <span *ngIf="form.get('surcharge')?.errors?.['required']"
                  >El surcharge es requerido</span
                >
                <span *ngIf="form.get('surcharge')?.errors?.['min']"
                  >El valor debe ser mayor o igual a 0</span
                >
              </div>
            </div>

            <div class="form-group">
              <label for="apply">Apply *</label>
              <select class="form-control" id="apply" formControlName="apply">
                <option value="">Seleccione una opción</option>
                <option value="all">All</option>
                <option value="selected">Selected</option>
              </select>
              <div
                class="error-message"
                *ngIf="form.get('apply')?.invalid && form.get('apply')?.touched"
              >
                Debe seleccionar una opción
              </div>
            </div>

            <div class="form-group">
              <label for="category">Category</label>
              <input
                type="text"
                class="form-control"
                id="category"
                formControlName="category"
              />
            </div>

            <div class="buttons-container">
              <button
                type="button"
                class="btn btn-default"
                (click)="onCancel()"
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="form.invalid || loading"
              >
                {{ id ? "Actualizar" : "Guardar" }}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="loading-overlay" *ngIf="loading">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </div>
  </div>
</div> -->

<!-- <h4 class="h4">(Courier Charges)</h4> -->
<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center mb-0">
      <div
        class="col column"
        *ngFor="let card of resumenCardsTwo; let i = index"
      >
        <div
          class="card card-stats__two"
          [ngClass]="{ 'card-stats__two--selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 4 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 4, 'text-white': i !== 4 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 4 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card-tools pb-5 pt-2">
          <div class="row">
            <div class="col-12">
              <!-- <a
                class="btn btn-dark btn-sm btn-fees-selected"
                [routerLink]="['/logistics/fees/surcharges']"
              >
                Customer Charges
              </a> -->
              <a
                class="btn btn-dark btn-sm btn-fees"
                [routerLink]="['/logistics/fees/surcharges']"
              >
                General
              </a>
              <a
                class="btn btn-dark btn-sm btn-fees"
                [routerLink]="['/logistics/fees/surcharges']"
              >
                Hoteles
              </a>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">receipt</i>
            </div>
            <h4 class="card-title">{{ id ? "Update" : "New" }} Surcharges</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="name">Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      formControlName="name"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('name')"
                    >
                      Name is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="items">Items</label>
                    <textarea
                      class="form-control"
                      id="items"
                      rows="1"
                      formControlName="items"
                      placeholder="Ingrese los items separados por comas"
                    ></textarea>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('items')"
                    >
                      Items is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="surcharge"
                      >Surcharge ($) *</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="surcharge"
                      formControlName="surcharge"
                      min="0"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('surcharge')"
                    >
                      Surcharge is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="apply"
                      >Apply *</label
                    >
                    <select
                      class="form-control"
                      id="apply"
                      formControlName="apply"
                    >
                      <option value="">Select an option</option>
                      <option value="pick-up">Pick-Up</option>
                      <option value="pick-up y drop">Pick-Up y Drop</option>
                      <option value="drop">Drop</option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('apply')"
                    >
                      Apply is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="surcharge"
                      >Surcharge ($) *</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="surcharge"
                      formControlName="surcharge"
                      min="0"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('surcharge')"
                    >
                      Surcharge is required
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="apply"
                      >Apply *</label
                    >
                    <select
                      class="form-control"
                      id="apply"
                      formControlName="apply"
                    >
                      <option value="">Select an option</option>
                      <option value="pick-up">Pick-Up</option>
                      <option value="pick-up y drop">Pick-Up y Drop</option>
                      <option value="drop">Drop</option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('apply')"
                    >
                      Apply is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="category"
                      >category * Does this category belong to a luxury
                      hotel?</label
                    >
                    <select
                      class="form-control"
                      id="category"
                      formControlName="category"
                    >
                      <option value="">
                        Does this category belong to a luxury hotel?
                      </option>
                      <option value="Hoteles de Lujo">Si</option>
                      <option value="No">No</option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('category')"
                    >
                      Category is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div class="custom-control custom-switch mt-4 checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Active</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-md-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-create"
                    [disabled]="form.invalid"
                  >
                    {{ id ? "Update" : "Create" }}
                  </button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
